import { render, staticRenderFns } from "./BlockRedeem.vue?vue&type=template&id=4839c8f9&"
import script from "./BlockRedeem.vue?vue&type=script&lang=js&"
export * from "./BlockRedeem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports